import { render, staticRenderFns } from "./baseEdit.vue?vue&type=template&id=020d8a7e&scoped=true"
import script from "./baseEdit.vue?vue&type=script&lang=js"
export * from "./baseEdit.vue?vue&type=script&lang=js"
import style0 from "./baseEdit.vue?vue&type=style&index=0&id=020d8a7e&prod&lang=scss&scoped=true"
import style1 from "./baseEdit.vue?vue&type=style&index=1&id=020d8a7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020d8a7e",
  null
  
)

export default component.exports